import styles from "./SkeletonRows.module.css";

export function SkeletonRows({ rows, label }: { rows: number; label: string }) {
  return (
    <div className={styles.tablePlaceholder} role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={styles.placeholderRow} />
      ))}
    </div>
  );
}
